import React from "react";
import Navbar from "../Components/Navbar/Navbar";
import ProductCard from "../Components/ProductCard/ProductCard";
import Footer from "../Components/Footer/Footer";
import { Box } from "@mui/material";
import CardImg from "../Assets/new_vegan_chicken_sticky_rice.png";
import { Helmet } from "react-helmet-async";
import useMetaTracking from "../hooks/useMetaTracking";

function VeganChickenXoi() {
  useMetaTracking("ViewContent", {
    content_name: "Savory Xoi - Vegan Chicken",
    content_category: "Vegan Menu",
    content_ids: ["savory_xoi_vegan_chicken"],
    content_type: "vegan_xoi",
    value: 6.0,
    currency: "USD",
  });

  return (
    <>
      <Helmet>
        <title>Vegan Chicken Xôi (Xôi Gà Chay) | Đông Hưng Viên Bakery</title>
        <meta
          name="description"
          content="Savory sticky rice mixed with vegan chicken and fried onions — Vietnamese comfort in every bite."
        />
        <meta
          property="og:title"
          content="Vegan Chicken Xôi (Xôi Gà Chay) | Đông Hưng Viên Bakery"
        />
        <meta
          property="og:description"
          content="Savory sticky rice mixed with vegan chicken and fried onions — Vietnamese comfort in every bite."
        />
        <meta property="og:image" content={CardImg} />
      </Helmet>

      <Box sx={{ pt: 10, background: '#0f0f0f' }}>
        <Navbar />

        <ProductCard
          cardImg={CardImg}
          titleHead="Vegan Chicken Xôi"
          titleSubHead="Xôi Gà Chay · $6.00 each"
          detailBody="Savory sticky rice mixed with vegan chicken and fried onions — a warm, comforting Vietnamese classic made vegan."
          detailBodyBr={
            <>
              Contains: coconut, soy, wheat
              <br />
              <br />
              <em>Vegan</em>
            </>
          }
          ProductCardBtn="View Full Vegan Menu"
          btnLink="/vegan-menu"
        />

        <Footer />
      </Box>
    </>
  );
}

export default VeganChickenXoi;
